module.exports = __webpack_public_path__ + "static/erika-06cf733e64d1614eddd60637f2b3ec77.jpg";